<ng-container *ngIf="showTopCategories">
    <div class="tab-pane mt-4 px-md-5" id="top-product" role="tabpanel" aria-labelledby="top-product-tab" tabindex="0">
        <div class="row g-lg-3 g-3 justify-content-center">
            <div class="col-6 col-md-3 col-lg-1 w-12 cursor-pointer" *ngFor="let subCategory of subCategoryData"
                (click)="subCategoriesRedirection(subCategory)">
                <!-- Thumbnail View -->
                <ng-container *ngIf="categoryView === 'thumbnail'; else buttonView">
                    <div class="topbar-product-card text-center pb-3">
                        <div class="bg-category">
                            <img [src]="cdnImagePath + subCategory?.category_image" alt="category img"
                                [title]="subCategory?.category_name" class="img-fluid catgory-img"
                                (error)="onSubcategoryImageError($event)" />
                            <h3 class="mb-1 d-block d-md-none" [title]="subCategory?.category_name">
                                <a class="product-title text-decoration-none sub-cat-thumbnail">
                                    {{ subCategory?.category_name | removeBackslash }}
                                </a>
                            </h3>
                        </div>
                        <div class="mt-0 mt-lg-3">
                            <h3 class="mb-1 d-none d-md-block" [title]="subCategory?.category_name">
                                <a class="product-title text-decoration-none sub-cat-thumbnail">
                                    {{ subCategory?.category_name | removeBackslash }}
                                </a>
                            </h3>
                        </div>
                    </div>
                </ng-container>
                <!-- Button View -->
                <ng-template #buttonView>
                    <div class="category-button" [title]="subCategory?.category_name">
                        {{ subCategory?.category_name | removeBackslash }}
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</ng-container>